// Die Status-Pille eines Kontakts (Entwurf v4 `.pill`): gefuellt, mit Punkt und
// Wort. Die Form unterscheidet zusaetzlich zur Farbe (WCAG 1.4.1): aktiv ein
// voller Punkt, Entwurf ein Ring, inaktiv ein eckiger Punkt. Der Punkt ist
// Zierde (Pseudo-Element), vorgelesen wird nur das Wort. Eine Pille fuer Liste
// und Kontaktkopf.

import type { ReactNode } from 'react';
import { Badge, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

import { lifecycleLabel } from '../parties.ts';

const FARBE: Readonly<Record<string, 'success' | 'warning' | 'informative'>> = {
  active: 'success',
  draft: 'warning',
  inactive: 'informative',
};

const useStyles = makeStyles({
  pille: {
    gap: '0.3125rem',
    fontWeight: tokens.fontWeightSemibold,
    '::before': {
      content: '""',
      width: '7px',
      height: '7px',
      borderRadius: '50%',
      backgroundColor: 'currentColor',
      flexShrink: 0,
    },
  },
  entwurf: {
    '::before': { backgroundColor: 'transparent', border: '1.5px solid currentColor', width: '6px', height: '6px', boxSizing: 'border-box' },
  },
  inaktiv: {
    '::before': { borderRadius: '1px' },
  },
});

export function StatusPille({ status, className }: { readonly status: string; readonly className?: string }): ReactNode {
  const own = useStyles();
  return (
    <Badge
      appearance="tint"
      color={FARBE[status] ?? 'informative'}
      className={mergeClasses(own.pille, status === 'draft' && own.entwurf, status === 'inactive' && own.inaktiv, className)}
    >
      {lifecycleLabel(status)}
    </Badge>
  );
}
